const feedbackModalStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col gap-[10px] md:gap-[12px] items-center justify-center rounded-[8px] bg-white p-[20px] pt-[15px] md:p-[25px] md:pt-[20px] w-[90%] screen-500:w-[380px] md:screen-500:w-[430px] text-black shadow-xl overflow-hidden relative`,
    header: `w-full flex items-center md:items-end gap-[10px] md:gap-[13px]`,
    title: `text-[16px] md:text-[18px] capitalize font-Suisse`,
    feedbackIcon: `max-w-[32px] md:max-w-[40px] w-full h-auto`,
    closeButton: `absolute top-[2px] md:top-[1px] right-2`,
    form: `flex flex-col gap-4 md:gap-6 w-full`,
    label: `text-[10px] font-medium mb-1 text-[#8B8E98]`,
    inputWrapper: `flex flex-col gap-1 w-full`,
    textArea: `font-Kanit !text-[13px] md:!text-[14px] placeholder:!text-[#8C8C8C] placeholder:opacity-100 !m-0 !p-2`,
    textAreaWrapper: (isError) => `bg-[#F5F9FF] rounded-[8px] p-1 flex border transition-colors ${isError ? "border-red-500" : "border-[#D1D5DB] hover:border-[#9CA3AF]"}`,
    footerButtons: `flex justify-between items-center gap-2 md:gap-4 mt-1 md:mt-2 w-full`,
    cancelButton: `flex-1 py-1.5 px-2 md:py-2 md:px-6 rounded-[6px] md:rounded-[8px] border border-gray-300 text-black font-normal hover:bg-gray-100 transition-colors text-center cursor-pointer text-[13px] md:text-[16px] whitespace-nowrap`,
    submitButton: (isDisabled) => `flex-1 px-2 py-[6px] md:px-[25px] md:py-[8px] rounded-[4px] lg:rounded-[6px] text-[13px] md:text-[16px] font-[400] leading-[normal] transition-colors text-center whitespace-nowrap ${isDisabled ? "bg-primaryHeading text-white opacity-50 pointer-events-none" : "bg-primaryHeading text-white hover:opacity-80 cursor-pointer"}`,
    muiLabel: {
        color: "#8B8E98",
        fontSize: "10px",
        fontWeight: 500,
        marginBottom: "4px"
    },
    // MUI Input Overrides (Matched to system defaults)
    muiInputProps: {
        sx: {
            '& .MuiOutlinedInput-root': {
                backgroundColor: '#F5F9FF',
                borderRadius: '8px',
                color: 'black',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#D1D5DB',
                    borderWidth: '1px',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#9CA3AF',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#c00',
                    borderWidth: '1px',
                },
            },
            '& .MuiInputBase-input:-webkit-autofill, & .MuiInputBase-input:-webkit-autofill:hover, & .MuiInputBase-input:-webkit-autofill:focus, & .MuiInputBase-input:-webkit-autofill:active': {
                WebkitBoxShadow: '0 0 0 1000px #F5F9FF inset !important',
                WebkitTextFillColor: 'black !important',
                transition: 'background-color 5000s ease-in-out 0s',
                borderRadius: '8px',
            },
            '& .MuiInputBase-input::placeholder': {
                color: '#8C8C8C',
                opacity: 1,
            },
        }
    }
}

export { feedbackModalStyles }
